import * as React from 'react';
import { TabsContext } from './tabs-context';
export var Tabs = function (_a) {
    var baseId = _a.baseId, fullWidth = _a.fullWidth, onChange = _a.onChange, selectedValue = _a.value, isLazy = _a.isLazy, children = _a.children;
    var getTabPanelId = function (value) { return "".concat(baseId, "-tabpanel-").concat(value); };
    var getTabId = function (value) { return "".concat(baseId, "-tab-").concat(value); };
    var getTabProps = function (value) {
        return {
            id: getTabId(value),
            'aria-controls': getTabPanelId(value),
        };
    };
    var getTabPanelProps = function (value) {
        return {
            role: 'tabpanel',
            hidden: selectedValue !== value,
            id: getTabPanelId(value),
            'aria-labelledby': getTabId(value),
        };
    };
    var ctxValue = React.useMemo(function () { return ({
        onChange: onChange,
        getTabProps: getTabProps,
        getTabPanelProps: getTabPanelProps,
        value: selectedValue,
        isLazy: isLazy,
        fullWidth: fullWidth,
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedValue, baseId, onChange, isLazy, fullWidth]);
    return React.createElement(TabsContext.Provider, { value: ctxValue }, children);
};
